import React from 'react';
import PropTypes from 'prop-types';
import styles from './ArticleValidationField.module.scss';

import { CheckIcon, CloseXIcon } from '../../../../common/icons';

const ArticleValidationField = ({
  field, fieldName, newspost = { title: '', url: '' }, onBlur, onChange, required = false, resetLink, validLink,
}) => {
  const containerClasses = `${styles['input-container']} ${validLink ? styles.valid : ''} ${field.touched && field.errors.length ? styles.invalid : ''}`;
  return (
    <label className={styles.field} htmlFor={fieldName}>
      <div className={styles.label}>
        <span id={`${fieldName}-label`} className={styles.labelText}>
          {field.label}
        </span>
        {required && <span className={styles.required}>*</span>}
      </div>
      {field.description && <div className={styles.description}>{field.description}</div>}
      <div className={containerClasses}>
        {validLink ? (
          <>
            <div className={styles.icon}>
              <CheckIcon size={16} />
            </div>
            <div className={styles.input}>
              {/* Ensure the anchor is associated with the label by using aria-labelledby */}
              <a href={newspost.url} aria-labelledby={`${fieldName}-label`}>{newspost.title}</a>
            </div>
            {/* Add aria-label to button for accessibility */}
            <button type="button" className={styles.close} onClick={resetLink} aria-label="Reset link">
              <CloseXIcon size={24} />
            </button>
          </>
        ) : (
          <input
            aria-labelledby={`${fieldName}-label`}
            className={styles.input}
            type="text"
            id={fieldName}
            name={fieldName}
            placeholder={field.placeholder}
            value={field.value}
            onChange={onChange}
            onBlur={onBlur}
            style={{ marginBottom: '0' }}
          />
        )}
      </div>
      {field.touched
        && field.errors.map((error) => (
          <p className={styles.error} key={error}>
            {error}
          </p>
        ))}
    </label>
  );
};

ArticleValidationField.propTypes = {
  field: PropTypes.shape({
    description: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.string,
    touched: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.string,
    valid: PropTypes.bool,
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  newspost: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  resetLink: PropTypes.func.isRequired,
  validLink: PropTypes.bool.isRequired,
};

export default ArticleValidationField;
